// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import Icon from '@mui/material/Icon'
import { CSSProperties, FC, ReactNode } from 'react'

const DEFAULT_SYMBOL_FONT_VARIATIONS =
  "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24"

type MaterialSymbolIconProps = {
  size?: number | string
  color?: string
  htmlColor?: string
  className?: string
  style?: CSSProperties
  sx?: Record<string, unknown>
  children?: ReactNode
  'data-testid'?: string
}

export type MaterialSymbolIcon = FC<MaterialSymbolIconProps>

export function createMaterialSymbolIcon(ligature: string): MaterialSymbolIcon {
  function MaterialSymbolIconComponent({
    size,
    color,
    htmlColor,
    style,
    sx,
    ...props
  }: MaterialSymbolIconProps): JSX.Element {
    return (
      <Icon
        baseClassName="material-symbols-outlined"
        sx={{
          fontVariationSettings: DEFAULT_SYMBOL_FONT_VARIATIONS,
          fontSize: size,
          color: htmlColor ?? color,
          ...sx,
        }}
        style={style}
        {...props}
      >
        {ligature}
      </Icon>
    )
  }

  MaterialSymbolIconComponent.displayName = `MaterialSymbol(${ligature})`
  return MaterialSymbolIconComponent
}
